import { Component, input, OnInit, Pipe } from '@angular/core';

@Component({
    selector: 'app-view-report-type',
    templateUrl: './view-report-type.component.html',
    styleUrls: ['./view-report-type.component.scss'],
    standalone: false
})


export class ViewReportTypeComponent implements OnInit {

  report_type_long = ""
  report = input.required<any>();
  constructor() {}

  ngOnInit(): void {
    if (this.report().report_type == "No Treatment") {
      this.report_type_long = "No Treatment Recommendation"
    }
    if (this.report().report_type == "Emergency Stabilization") {
      this.report_type_long = "Funding Request for Estimated Emergency Stabilization Funds"
    }
    if (this.report().report_type == "Pre-assessment Request") {
      this.report_type_long = "Pre-assessment Funding Request"
    }
  }

}